// import React, { useEffect } from "react";
import classes from "./ProductCard.module.css";
// import Button from "../utils/Butto

import DetailButton from "./DetailButton";
import DeleteButton from "./DeleteButton";
import EditButton from "./EditButton";
import AddToCartButton from "./AddToCartButton";
// import LoginOrRegisterButton from "./LoginOrRegisterButton";
import useUserStore from "../store/useUserStore";
import ButtonLink from "../utils/ButtonLink";

export default function ProductCard(props) {
  const { user } = useUserStore((state) => state);

  return (
    <>
      <div className={classes.productCard}>
        <div>
          <img className={classes.CardImage} src={props.image} alt="product" />
        </div>
        <div className={classes.productContent}>
          <div className={classes.prductHeading}>
            <h4>{props.title}</h4>
            <span>{props.category}</span>
          </div>
          <span className={classes.productPrice}>{props.price}€</span>
        </div>
        <div className={classes.cardActions}>
          {user ? (
            <AddToCartButton id={props.id}>Add TO Cart</AddToCartButton>
          ) : (
            <ButtonLink
              style={{
                width: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "1.4rem 1rem",
              }}
              to="/login"
            >
              Log-in To Buy
            </ButtonLink>
          )}
          <DetailButton class={classes.media} id={props.id}>
            Details
          </DetailButton>
          {user?.isAdmin && <DeleteButton id={props.id}>Delete</DeleteButton>}
          {user?.isAdmin && <EditButton id={props.id}>Edit</EditButton>}
        </div>
      </div>
    </>
  );
}
